var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailgatingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "25px",
    viewBox: "0 0 47 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graph/TAILGATE Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph/TAILGATE-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/trailer_grey",
    transform: "translate(0.167785, 9.395973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56375839,11.6227768 C9.01989234,10.5032558 7.87187977,9.73154362 6.54362416,9.73154362 C5.05156281,9.73154362 3.78694236,10.7053338 3.3506349,12.0520422 L9.09494702e-13,12.0520422 L9.09494702e-13,0 L18.6241611,0 L18.6241611,12.0520422 C17.3421197,12.0520422 16.4137793,12.0520422 15.8391399,12.0520422 L15.7768819,12.0520422 C15.3405744,10.7053338 14.075954,9.73154362 12.5838926,9.73154362 C11.255637,9.73154362 10.1076244,10.5032558 9.56375839,11.6227768 Z",
    id: "Combined-Shape",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 1.17449664,
    cx: 6.54362416,
    cy: 13.0872483,
    r: 1.9295302
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 1.17449664,
    cx: 12.5838926,
    cy: 13.0872483,
    r: 1.9295302
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8394611,8.7755102 L21.0606945,8.7755102 L20.864945,0.33557047 L23.0437214,0.33557047 L22.8394611,8.7755102 Z M20.8053691,11.3559786 C20.8053691,11.0436911 20.9103352,10.784825 21.1202704,10.5793727 C21.3302056,10.3739204 21.6167346,10.2711957 21.9798658,10.2711957 C22.342997,10.2711957 22.6295259,10.3739204 22.8394611,10.5793727 C23.0493964,10.784825 23.1543624,11.0436911 23.1543624,11.3559786 C23.1543624,11.6573087 23.0522333,11.9093265 22.847972,12.1120394 C22.6437107,12.3147524 22.3543448,12.4161074 21.9798658,12.4161074 C21.6053867,12.4161074 21.3160209,12.3147524 21.1117596,12.1120394 C20.9074982,11.9093265 20.8053691,11.6573087 20.8053691,11.3559786 Z",
    id: "!",
    fill: "#EB3C39",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "graph/truck_grey",
    transform: "translate(20.134228, 9.395973)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 1.17449664,
    cx: 18.7919463,
    cy: 13.0872483,
    r: 1.9295302
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 1.17449664,
    cx: 4.19463087,
    cy: 13.0872483,
    r: 1.9295302
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 1.17449664,
    cx: 24.1610738,
    cy: 13.0872483,
    r: 1.9295302
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7655015,10.5704698 L22.1876538,10.5704698 C22.0702121,10.6391944 21.9522349,10.7328131 21.8337222,10.8513258 C21.7152095,10.9698385 21.5961613,11.1132452 21.4765777,11.2815459 C21.359136,11.1132452 21.2411588,10.9698385 21.1226461,10.8513258 C21.0041334,10.7328131 20.8850852,10.6391944 20.7655015,10.5704698 Z",
    id: "Path-3",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7651007,0.167785235 C14.7990416,0.0559284116 14.8549701,0 14.9328859,0 C15.0108018,0 15.0667302,0.0559284116 15.1006711,0.167785235 L15.2684564,0.503355705 L15.2684564,4.77660624 C15.2684564,4.83235814 15.2961493,4.88446871 15.342356,4.91566514 L15.6979125,5.15571908 C15.7441191,5.18691551 15.7718121,5.23902608 15.7718121,5.29477797 L15.7718121,9.56375839 L15.4555381,9.89932886 L14.9328859,9.89932886 L14.404217,9.89932886 L14.0939597,9.56375839 L14.0939597,5.31081396 C14.0939597,5.25655113 14.1202019,5.20563841 14.164398,5.17415578 L14.5268772,4.91594775 C14.5710733,4.88446512 14.5973154,4.8335524 14.5973154,4.77928958 L14.5973154,0.503355705 L14.7651007,0.167785235 Z",
    id: "Rectangle",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04026846,4.56226651 C6.15806489,4.31717608 6.32585013,4.19463087 6.54362416,4.19463087 C7.10290828,4.19463087 7.55033557,4.19463087 7.88590604,4.19463087 C8.19723367,2.24842297 9.53992719,1.01799792 11.9139866,0.503355705 L13.9261745,0.503355705 L13.9261745,10.5704698 L16.2751678,10.5704698 L16.2751678,11.1303151 C15.8545562,11.6704805 15.6040268,12.3496073 15.6040268,13.0872483 L7.38255034,13.0872483 C7.38255034,11.326609 5.95527018,9.89932886 4.19463087,9.89932886 C2.43399157,9.89932886 1.00671141,11.326609 1.00671141,13.0872483 L-5.68434189e-14,13.0872483 L-5.68434189e-14,8.18280426 C0.116156459,8.06024408 0.301945479,7.95907921 0.557367059,7.87930965 L6.04026846,7.55033557 L6.04026846,4.56226651 Z M7.04697987,4.86577181 C6.86164941,4.86577181 6.7114094,5.01601183 6.7114094,5.20134228 L6.7114094,7.2147651 C6.7114094,7.40009555 6.86164941,7.55033557 7.04697987,7.55033557 L9.06040268,7.55033557 C9.24573314,7.55033557 9.39597315,7.40009555 9.39597315,7.2147651 L9.39597315,5.20134228 C9.39597315,5.01601183 9.24573314,4.86577181 9.06040268,4.86577181 L7.04697987,4.86577181 Z",
    id: "Combined-Shape",
    fillOpacity: 0.87,
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailgatingIcon);
export default __webpack_public_path__ + "static/media/tailgating_icon.3c67e707a2e7c55a75fc7417e0cce3e3.svg";
export { ForwardRef as ReactComponent };